import { render, staticRenderFns } from "./BonusBetTokenSymbol.vue?vue&type=template&id=93cf6470&"
import script from "./BonusBetTokenSymbol.vue?vue&type=script&lang=js&"
export * from "./BonusBetTokenSymbol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports